import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { useSelector } from "react-redux";
import { money } from "../../utilities/currency";
import VippsAuthenticate from "./vippsauthenticate.tsx";
import WalletAuthenticate from "./walletauthenticate.tsx";
import StripeAuthenticate from "./stripeauthenticate.tsx";
import WaitingAgent from "./waitingagent.tsx";
import Swal from "sweetalert2";
import ResponseAgent from "./responseagent.tsx";
import WaitingCallback from "./waitingcallback.tsx";

export function CallModal({
  show,
  onClose,
  baseUrl,
  agent_uid,
  minutePrice,
  currentUser,
  callStartupFee,
  webSocketConn,
  responseAgent,
  setResponseAgent,
  waitingAgentCheck, // <-- Add this line
  setWaitingAgentCheck,
  vippsAuthenticate,
  setVippsAuthenticate,
  walletAuthenticate,
  setWalletAuthenticate,
  stripeAuthenticate,
  setStripeAuthenticate,
  callResponseObj,
  setCallResponseObj,
  handleCancelConvertCallToCallback,
  handleConvertCallToCallback,
  waitingCallback,
  waitingCallbackInfo,
  onLoginSuccess,
}) {
  const mintPresets = [5, 10, 15, 20, 30];
  const paymentPresets = ["invoice", "card", "vipps", "wallet"];
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [selected, setSelected] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const client = useSelector((state) => state.client.client);
  const client_uid = client?.uid || "clnt_QI9Jd1m0";
  const [price, setPrice] = useState(null);


  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState({ code: "+47", country: "Norway", flag: "🇳🇴" });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  // Dummy country options for testing without API
  const countryOptions = [
    { code: "+47", country: "Norway", flag: "🇳🇴" },
    { code: "+46", country: "Sweden", flag: "🇸🇪" },
    { code: "+45", country: "Denmark", flag: "🇩🇰" },
    { code: "+358", country: "Finland", flag: "🇫🇮" },
    { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
    { code: "+1", country: "United States", flag: "🇺🇸" },
    { code: "+34", country: "Spain", flag: "🇪🇸" },
    { code: "+49", country: "Germany", flag: "🇩🇪" },
  ];

  useEffect(() => {
    // Simulate auto-detection for dummy testing
    const detected = { code: "+47", country: "Norway", flag: "🇳🇴" };
    setCountryCode(detected);
  }, []);

  // Close dropdown on outside click or Esc key
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    function handleEsc(event) {
      if (event.key === "Escape") setDropdownOpen(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const filteredCountries = countryOptions.filter((option) =>
    option.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
    option.code.includes(searchTerm)
  );

  // const [responseAgent, setResponseAgent] = useState(false);

  //reset states on close
  useEffect(() => {
    if (!show) {
      setPaymentMethod("card");
      setSelected(10);
      setLoading(false);
      setError("");
      setVippsAuthenticate(false);
      setWalletAuthenticate(false);
      setStripeAuthenticate(false);
      setWaitingAgentCheck(false);
      // setResponseAgent(false);
      setCallResponseObj(null);
      onCalculatePrice(10);
    }
  })

  // ESC key to close
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    if (show) window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [show, onClose]);

  const onCalculatePrice = React.useCallback((minutes) => {
    let total = 0;
    if (minutePrice) {
      total = minutes * parseFloat(minutePrice);
      total = total + (callStartupFee ? parseFloat(callStartupFee) : 0);
      total = money(`${total.toFixed(2)}`);
    }
    setPrice(total);
  })
  const onSelectMinutes = (minutes) => {
    setSelected(minutes);
    onCalculatePrice(minutes);
  };

  useEffect(() => {
    onCalculatePrice(selected);
  }, [selected, onCalculatePrice]
  )

  useEffect(() => {
    const channel = new BroadcastChannel("chamcore-approve-payment");
    channel.onmessage = (event) => {
      if (event.data?.type === "CARD_PAYMENT_APPROVED") {
        if (webSocketConn?.readyState !== WebSocket.OPEN) {
          var wsServer = "";
          if (baseUrl.includes("localhost")) {
            wsServer = "ws://localhost:8013/echo";
          } else {
            wsServer = "wss://chamcore.com/echo";
          }
          webSocketConn = new WebSocket(wsServer);
        }

        var data = {
          call_history_id: event.data?.call_id,
          about: "WebCall_initated_call",
          channel: "common_channel",
          type: 'audio_call',
        }
        setTimeout(() => {
          webSocketConn.send(JSON.stringify(data));
        }, 1000);
        // set waiting for the agent to receive the call
        setStripeAuthenticate(false);
        setWaitingAgentCheck(true);
        // setResponseAgent(false);
      }
    };
    return () => channel.close();
  }, []);

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const handleCall = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const formData = new FormData();
    formData.append("client_uid", client_uid);
    formData.append("payment_method", paymentMethod);
    formData.append("minutes_talk", selected);
    formData.append("agent_uid", agent_uid);
    if (currentUser) {
      formData.append("token", currentUser.token);
    } else {
      formData.append("countryCode", countryCode.code);
      formData.append("phoneNumber", phoneNumber);

      // if (paymentMethod !== "vipps") {
      //   // Paste your VAPID public key here (base64 urlsafe)
      //   const VAPID_PUBLIC_KEY = 'BL1p6Elf7F9-UuePofmyrNqhN2G7j9fyLz5n1VDWMIxWn3Ptd6pBT-GSSi4corP1CT25rcm_TaMfVUSEoqYzoAs';

      //   const reg = await navigator.serviceWorker.ready;
      //   const sub = await reg.pushManager.getSubscription();
      //   let subscription = sub;
      //   if (!subscription) {
      //     subscription = await reg.pushManager.subscribe({
      //       userVisibleOnly: true,
      //       applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      //     });
      //   }


      //   // send to backend
      //   const rawKey = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('p256dh'))));
      //   const authKey = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))));
      //   formData.append("fingerprint", rawKey + ":" + authKey);
      // }
    }
    try {
      if (paymentMethod === "vipps") {
        setVippsAuthenticate(true);
      } else if (paymentMethod === "wallet") {
        setWalletAuthenticate(true);
      } else if (paymentMethod === "card") {
        setStripeAuthenticate(true);
      }
      const response = await axios.post(baseUrl + "/buyMinutesForWebCall", formData);
      console.log("Login success:", response.data);

      if (!currentUser) {
        if (typeof onLoginSuccess === "function") {
          onLoginSuccess(response.data?.token, "customer", response.data?.name);
        }
      }

      const { reference, access_token, customer_uid, call_id, agent_name } = response.data;
      if (paymentMethod === "vipps" && response.data.status === "OK") {
        var formData1 = new FormData();
        formData1.append("customer_uid", customer_uid);
        formData1.append("access_token", access_token);
        formData1.append("reference", reference);
        formData1.append("call_id", call_id);
        formData1.append("client_uid", client_uid);

        const pollAuth = async (intervalId) => {
          try {
            const secondRes = await axios.post(baseUrl + "/confirmWebCallVipps", formData1);

            console.log("Polling result:", secondRes.data);

            if (secondRes.data.status && secondRes.data.status === "AUTHORIZED") {
              setVippsAuthenticate(false);
              clearInterval(intervalId); // ✅ stop polling

              if (webSocketConn.readyState !== WebSocket.OPEN) {
                var wsServer = "";
                if (baseUrl.includes("localhost")) {
                  wsServer = "ws://localhost:8013/echo";
                } else {
                  wsServer = "wss://chamcore.com/echo";
                }
                webSocketConn = new WebSocket(wsServer);
              }

              var data = {
                call_history_id: call_id,
                about: "WebCall_initated_call",
                channel: "common_channel",
                type: 'audio_call',
              }
              setTimeout(() => {
                webSocketConn.send(JSON.stringify(data));
              }, 1000);
              // set waiting for the agent to receive the call
              setWaitingAgentCheck(true);
              // setResponseAgent(false);
            } else if (secondRes.data.status && secondRes.data.status === "ABORTED") {
              setVippsAuthenticate(false);
              clearInterval(intervalId); // ✅ stop polling
              Swal.fire({
                icon: "error",
                title: "Betaling avbrutt",
                text: "Du har avbrutt betalingen.",
                showConfirmButton: true,
              });
            }
          } catch (err) {
            clearInterval(intervalId); // stop polling on error
            setError("Noe gikk galt. Prøv igjen.");
          }
        };

        // Start polling every 2s
        const intervalId = setInterval(() => pollAuth(intervalId), 2000);
      } else if (paymentMethod === "card" && response.data.status === "OK") {
        setStripeAuthenticate(false);

        if (webSocketConn.readyState !== WebSocket.OPEN) {
          var wsServer = "";
          if (baseUrl.includes("localhost")) {
            wsServer = "ws://localhost:8013/echo";
          } else {
            wsServer = "wss://chamcore.com/echo";
          }
          webSocketConn = new WebSocket(wsServer);
        }

        var data = {
          call_history_id: response.data.call_id,
          about: "WebCall_initated_call",
          channel: "common_channel",
          type: 'audio_call',
        }
        webSocketConn.send(JSON.stringify(data));
        // set waiting for the agent to receive the call
        setWaitingAgentCheck(true);
      } else if (paymentMethod === "card" && response.data.status === "NO_FINGERPRINT") {
        Swal.fire({
          icon: "error",
          title: "Enhetsautentisering mislyktes",
          text: "Denne enheten er ikke autorisert for betaling. Vennligst logg inn først for å autorisere.",
          showConfirmButton: true,
        });
        setStripeAuthenticate(false);
      }

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };



  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            className="relative bg-white rounded-2xl shadow-xl w-full max-w-md p-6"
          >
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
            >
              ✕
            </button>

            {vippsAuthenticate ? (
              <VippsAuthenticate vippsAuthenticate={vippsAuthenticate} />
            ) : walletAuthenticate ? (
              <WalletAuthenticate walletAuthenticate={walletAuthenticate} />
            ) : stripeAuthenticate ? (
              <StripeAuthenticate stripeAuthenticate={stripeAuthenticate} />
            ) : waitingAgentCheck ? (
              <WaitingAgent waitingAgentCheck={waitingAgentCheck} />
            ) : responseAgent ? (
              <ResponseAgent responseAgent={responseAgent} response={callResponseObj} handleCancelConvertCallToCallback={handleCancelConvertCallToCallback} handleConvertCallToCallback={handleConvertCallToCallback} />
            ) : waitingCallback ? (
              <WaitingCallback waitingCallback={waitingCallback} waitingCallbackInfo={waitingCallbackInfo} />
            )
              : (
                <>
                  <h2 className="text-xl font-bold mb-4">Velg minutter & betaling</h2>
                  <form onSubmit={handleCall} className="space-y-6">
                    {/* Minutes Selection */}
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-2">
                        Velg minutter:
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {mintPresets.map((minutes) => (
                          <button
                            key={minutes}
                            type="button"
                            onClick={() => onSelectMinutes(minutes)}
                            className={`px-3 py-1 rounded-full text-sm font-semibold transition border 
                  ${selected === minutes
                                ? "bg-purple-600 text-white border-purple-600"
                                : "bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-200"
                              }`}
                          >
                            {minutes} min
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="text-center">
                      <p className="text-sm text-gray-600" id="total-amount">{price}</p>
                    </div>

                    {/* Payment Method Selection */}
                    <div>
                      <p className="text-sm font-semibold text-gray-600 mb-2">
                        Betalingsmetode:
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {paymentPresets.map((method) => (
                          <button
                            key={method}
                            type="button"
                            onClick={() => setPaymentMethod(method)}
                            className={`px-3 py-1 rounded-full text-sm font-semibold transition border capitalize
                  ${paymentMethod === method
                                ? "bg-pink-600 text-white border-pink-600"
                                : "bg-pink-100 text-pink-800 border-pink-200 hover:bg-pink-200"
                              }`}
                          >
                            {method}
                          </button>
                        ))}
                      </div>

                      {!currentUser ? (
                        <div className="mt-4">
                          <div className="text-sm text-gray-600 font-medium pt-2">Phone number</div>
                          <div className="flex items-center gap-2 relative" ref={dropdownRef}>
                            <div className="relative">
                              <input
                                type="text"
                                placeholder="Type country or code..."
                                value={searchTerm || `${countryCode.flag} ${countryCode.country} ${countryCode.code}`}
                                onFocus={() => setDropdownOpen(true)}
                                onChange={(e) => {
                                  setSearchTerm(e.target.value);
                                  setDropdownOpen(true);
                                }}
                                className="w-32 border focus:border-purple-600 focus:ring-purple-600 rounded-full text-sm px-4 py-2"
                              />
                              {dropdownOpen && (
                                <div className="absolute top-10 left-0 w-48 bg-white border border-purple-100 rounded-lg shadow-lg max-h-40 overflow-y-auto z-20">
                                  {filteredCountries.map((option) => (
                                    <div
                                      key={option.code}
                                      onClick={() => {
                                        setCountryCode(option);
                                        setSearchTerm(`${option.flag} ${option.country} ${option.code}`);
                                        setDropdownOpen(false);
                                      }}
                                      className="px-3 py-2 text-sm hover:bg-purple-50 cursor-pointer flex items-center gap-2"
                                    >
                                      <span>{option.flag}</span> <span>{option.country}</span> <span>{option.code}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>

                            <input
                              type="tel"
                              placeholder="900 12 345"
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              className="flex-1 border focus:border-purple-600 focus:ring-purple-600 rounded-full px-4 py-2"
                            />
                          </div>
                        </div>
                      ) : ('')}

                    </div>

                    {error && <p className="text-sm text-red-600">{error}</p>}

                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full mt-4 bg-purple-600 hover:bg-purple-700 text-white rounded-full py-2 font-semibold"
                    >
                      {loading ? "Starter samtale..." : "Start samtale"}
                    </button>
                  </form>
                </>
              )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
